import ActionTypes from 'app/shared-zap/ActionTypes';
import reducer from 'app/shared-zap/reducer';
import routes from 'app/shared-zap/routes';

export default {
  actionTypes: ActionTypes,
  reducers: {
    sharedZap: reducer,
  },
  routes,
};
